"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadGameForm = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var constants = require("../constants");
exports.LoadGameForm = vue_1.default.component('load-game-form', {
    components: {
        'Button': Button_1.Button,
    },
    data: function () {
        return {
            constants: constants,
            gameId: '',
            rollbackCount: '0',
        };
    },
    methods: {
        loadGame: function () {
            var _this = this;
            var gameId = this.$data.gameId;
            var rollbackCount = this.$data.rollbackCount;
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', '/load_game');
            xhr.onerror = function () {
                alert('Error loading game');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var response = xhr.response;
                    if (response.players.length === 1) {
                        window.location.href = '/player?id=' + response.players[0].id;
                        return;
                    }
                    else {
                        window.history.replaceState(response, constants.APP_NAME + " - Game", '/game?id=' + response.id);
                        _this.$root.$data.game = response;
                        _this.$root.$data.screen = 'game-home';
                    }
                }
                else {
                    alert('Unexpected server response');
                }
            };
            xhr.responseType = 'json';
            xhr.send(JSON.stringify({
                game_id: gameId,
                rollbackCount: rollbackCount,
            }));
        },
    },
    template: "\n        <div id=\"load-game\">\n            <h1><span v-i18n>{{ constants.APP_NAME }}</span> \u2014 <span v-i18n>Load Game</span></h1>\n\n            <div class=\"load-game-form load-game--block\">\n                <div class=\"container load-game-options\">\n                    <div >\n                        <label for=\"gameId\">Game Id to reload:</label><br/>\n                        <input class=\"form-input form-inline load-game-id\" :placeholder=\"'Game Id'\" v-model=\"gameId\" /><br/>\n                        <label for=\"rollbackCount\">Number of saves to delete before loading:</label><br/>\n                        <input class=\"form-input form-inline load-game-id\" value=\"0\" v-model=\"rollbackCount\" /><br/>\n                        <Button title=\"Load Game\" size=\"big\" type=\"success\" :onClick=\"loadGame\" />\n                    </div>\n                </div>\n            </div>\n        </div>\n    ",
});
//# sourceMappingURL=LoadGameForm.js.map